import { PermissionPolicy } from '../model';
import { RIGHT_KEYS } from '../security.const';

export interface ResourcePermission {
    rights: string[];
    policy?: PermissionPolicy;
}

const RESOURCE_PERMISSIONS_CONFIG: { [accessKey: string]: ResourcePermission } = {
    'TestHarness': {
        rights: [
            RIGHT_KEYS.LabAccess,
            RIGHT_KEYS.TestHarnessAccess
        ],
        policy: PermissionPolicy.Any
    },

    'AddLab': {
        rights: [
            RIGHT_KEYS.LabAccess,
            RIGHT_KEYS.LabAdd
        ],
        policy: PermissionPolicy.All
    },

    'AccessExpiredLab': {
        rights: [
            RIGHT_KEYS.LabAccessExpired,
        ],
        policy: PermissionPolicy.Any
    },

    'UserManagement': {
        rights: [
            RIGHT_KEYS.UserManagement
        ],
        policy: PermissionPolicy.All
    },

    'LabAccessAll': {
        rights: [
          RIGHT_KEYS.LabAccessAll
        ],
        policy: PermissionPolicy.All
    }
};

export function GetResourcePermissionsByKey(key: string): ResourcePermission {
    const config = RESOURCE_PERMISSIONS_CONFIG[key];
    if (!config) {
        throw new Error(`Resource Permissions With '${key}' has not been found`);
    }

    return config;
}





// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/security/access-control/resource-permissions.config.ts